"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChunk = exports.createChunk = void 0;

function createChunk(from, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var chunk = {
    props: props || {},
    children: children
  };

  if (typeof from === "string") {
    chunk.tagName = from;
  } else {
    chunk.rule = from;
  }

  return chunk;
}

exports.createChunk = createChunk;

function isChunk(obj) {
  return typeof obj !== "string" && "props" in obj && "children" in obj;
}

exports.isChunk = isChunk;